import { render, staticRenderFns } from "./TournamentBulletin.vue?vue&type=template&id=d4b287e8&"
import script from "./TournamentBulletin.vue?vue&type=script&lang=js&"
export * from "./TournamentBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports